import React, { useEffect } from 'react';

import { classNames } from '@/shared/helpers';
import type { IDefaultLayout } from '@/interfaces/Layouts';
import { getHeaderBackground } from '@/components/Headers/MainHeader/utils';

import Mobile from './Mobile';
import Desktop from './Desktop';
import './styles.scss';
import PartnershipBannerWidget from '../PartnershipBannerWidget';

const SCROLL_LIMIT_TO_APPLY_BG = 150;

interface HeaderProps extends IDefaultLayout {}

const Header = ({
  templateData,
  pageContext,
  backgroundHeader,
  isHomePage,
  isInstitutionalPage,
  backgroundImage,
}: HeaderProps) => {
  const { general, home } = templateData;
  const shouldApplyContrast = general.colors.contrast;

  const mainHeaderBackground = getHeaderBackground({
    isHomePage,
    isInstitutionalPage,
    institutionalPageBg: backgroundHeader,
    homePageBg: backgroundImage,
  });

  useEffect(() => {
    if (window !== undefined && document !== undefined) {
      const mainHeader = document.querySelector('.main-header');

      window.addEventListener('scroll', () => {
        if (window.scrollY >= SCROLL_LIMIT_TO_APPLY_BG) {
          mainHeader?.classList.add('main-header-bg');
        } else {
          mainHeader?.classList.remove('main-header-bg');
        }
      });
    }
  }, []);

  return (
    <div className='header-container'>
      <PartnershipBannerWidget />

      <header
        className={classNames(
          'main-header',
          shouldApplyContrast ? 'text-with-contrast' : 'text-without-contrast'
        )}
        style={
          home.homeBgType !== 'video' || !isHomePage
            ? mainHeaderBackground
            : { backgroundColor: 'transparent' }
        }
      >
        <section className="header-container" aria-label="header-section">
          <Desktop pageContext={pageContext} />

          <Mobile pageContext={pageContext} />
          <div className="planne-widget planne-widget-open-purchase-notification notification-container" />
        </section>
      </header>
    </div>
  );
};

export default Header;
